import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/news';

export default function CategoryTabs() {
  const location = useLocation();

  return (
    <div className="w-full px-4 md:px-6">
      <div className="flex items-center gap-1 overflow-x-auto pb-2 scrollbar-hide flex-wrap">
        <Link
          to="/"
          className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
            location.pathname === '/'
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200'
          }`}
        >
          全部
        </Link>
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
              location.pathname === `/category/${cat.slug}`
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-600 hover:bg-background-200'
            }`}
          >
            {cat.name}
          </Link>
        ))}
      </div>
    </div>
  );
}